import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type MudancaLog = {
  id: string;
  mudanca_id: string;
  acao: string;
  tipo?: string | null;
  usuario_id?: string | null;
  usuario?: {
    name: string;
  } | null;
  criado_em: string;
};

export const useMudancaLogs = (mudancaId: string | undefined) => {
  const { data: logs = [], isLoading, error } = useQuery({
    queryKey: ['mudancaLogs', mudancaId],
    queryFn: async () => {
      if (!mudancaId) return [];
      
      // Primeiro buscar os logs
      const { data: logsData, error: logsError } = await supabase
        .from('mudanca_logs')
        .select('*')
        .eq('mudanca_id', mudancaId)
        .order('criado_em', { ascending: true });

      if (logsError) throw logsError;

      // Buscar informações dos usuários para cada log
      const logsWithUsers = await Promise.all(
        logsData.map(async (log) => {
          if (log.usuario_id) {
            const { data: userData } = await supabase
              .from('users')
              .select('name')
              .eq('id', log.usuario_id)
              .single();
            
            return {
              ...log,
              usuario: userData
            };
          }
          return {
            ...log,
            usuario: null
          };
        })
      );

      return logsWithUsers as MudancaLog[];
    },
    enabled: !!mudancaId,
  });

  return { logs, isLoading, error };
};
